<template>
  <div class="notifications__wrapper">
    <h2 class="notifications__title subtitle-3">Announcements</h2>

    <a-visibility show :on="[$breakpoint.mobile]">
      <div class="notifications__section-delimiter" />
    </a-visibility>

    <a-spinner
      v-if="inProgress"
      disable-transition
      class="notifications__spinner"
    />

    <template v-else-if="notifications.length">
      <div
        v-for="notification in notifications"
        :key="notification.Id"
        class="notifications__section__wrapper"
      >
        <announcement-notification
          :notification="notification"
          class="notifications__message"
        />
      </div>
    </template>

    <div
      v-else
      class="notifications__empty-content text-primary-navigation text-center"
    >
      There are no announcements
    </div>
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import AnnouncementNotification from './AnnouncementNotification'
import ASpinner from 'shared/ASpinner'
import { mapActionsLazy } from '@/plugins/helper'

const DEFAULT_TAKE = 5

export default {
  name: 'ANotifications',
  mixins: [mixins.urlGenerators],
  inheritAttrs: false,
  components: { ASpinner, AnnouncementNotification },
  data() {
    return {
      DEFAULT_TAKE,
      notifications: {},
      inProgress: false
    }
  },
  methods: {
    ...mapActionsLazy({
      requestAnnouncements: 'personal-area/requestAnnouncements',
      requestMarkReadBellIcon: 'notifications/requestMarkReadBellIcon'
    }),
    generatePayload({ take = DEFAULT_TAKE, page = 0 } = {}) {
      return {
        take,
        page
      }
    },
    async requestNotifications() {
      try {
        this.inProgress = true
        const { Announcements } = await this.requestAnnouncements({
          queryParams: this.generatePayload()
        })

        this.notifications = Announcements

        await this.$nextTick()
      } catch (err) {
        this.$errorHandler(err, this)
      } finally {
        this.inProgress = false
      }
    }
  },
  mounted() {
    this.requestNotifications()
    this.requestMarkReadBellIcon()
  }
}
</script>

<style lang="scss" scoped>
.notifications__wrapper {
  .notifications__title {
    text-align: left;
  }

  .notifications__section-delimiter {
    height: 1px;
    margin: 24px 0;
    background: $c--gray-dark;
    content: '';
  }

  .notifications__spinner {
    margin-top: 27px;
  }

  .notifications__section-title {
    margin-top: 20px;
    margin-bottom: 4px;
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    color: $c--white;
  }

  .notifications__empty-content {
    padding: 32px 0 12px;
  }
}
</style>
